import { Minus, Plus,Trash2, LoaderCircle } from "lucide-react";
import "./QuantitySelector.css";


export default function QuantitySelector({
    quantity,
    maxQuantity,
    onIncrease,
    onDecrease,
    isLoading = false,
}) {

    return (

        <div className="quantity-selector">

            <button
                className="quantity-btn"
                onClick={onIncrease}
                // disabled={quantity >= maxQuantity}                
                disabled={
                    // isIncreasing ||
                    isLoading ||
                    quantity >= maxQuantity
                }
            >
                {isLoading ? "..." : <Plus size={18} />}
              
            </button>

         
                <span className="quantity-value">
  
                {isLoading ? (
                    <LoaderCircle
                        size={25}  stroke={"#87a91f"}
                        className="quantity-spinner"
                    />
                ) : (
                    quantity
                )}

            </span>

            <button
                onClick={onDecrease}
                 disabled={isLoading}
                className={`quantity-btn ${quantity === 1 ? "remove-btn" : ""
                    }`}
            >
                {quantity === 1 ? (
                    <Trash2 size={18} />
                ) : (
                    <Minus size={18} />
                )}
            </button>

        </div>

    );

}